/**
 * 从本地视频文件截取首帧，生成 JPEG Blob（用于上传 COS 封面）
 */
export function isVideoFile(file) {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  if (type.startsWith('video/')) return true;
  const name = (file.name || '').toLowerCase();
  return /\.(mp4|mov|avi|mkv|webm|m4v|wmv|flv)$/.test(name);
}

export function captureVideoFirstFrame(file, seekSeconds = 1) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('视频文件为空'));
      return;
    }

    const video = document.createElement('video');
    video.preload = 'auto';
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', 'true');

    const objectUrl = URL.createObjectURL(file);
    video.src = objectUrl;

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
      video.removeAttribute('src');
      video.load();
    };

    const fail = (message) => {
      cleanup();
      reject(new Error(message));
    };

    video.onloadeddata = () => {
      const duration = video.duration;
      let target = seekSeconds;
      if (Number.isFinite(duration) && duration > 0) {
        target = Math.min(seekSeconds, Math.max(0, duration - 0.05));
      } else {
        target = 0;
      }
      try {
        video.currentTime = target;
      } catch (e) {
        fail('无法定位视频帧');
      }
    };

    video.onseeked = () => {
      try {
        const width = video.videoWidth || 640;
        const height = video.videoHeight || 360;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          fail('无法创建画布');
          return;
        }
        ctx.drawImage(video, 0, 0, width, height);
        canvas.toBlob((blob) => {
          if (blob) {
            cleanup();
            resolve(blob);
          } else {
            fail('无法生成视频封面');
          }
        }, 'image/jpeg', 0.88);
      } catch (e) {
        fail(e.message || '截取视频封面失败');
      }
    };

    video.onerror = () => fail('视频加载失败，无法提取封面');
  });
}
